import { Redirect, Route } from 'react-router-dom';

import type React from 'react';

type PrivateRouteProps = {
	isAuthenticated: unknown;
	isAuthInProgress?: boolean;
	component: React.ComponentType<any>;
	[key: string]: any;
};

export const PrivateRoute = ({
	isAuthenticated,
	isAuthInProgress = false,
	component: Component,
	...rest
}: PrivateRouteProps) => {
	return (
		<Route
			{...rest}
			component={(props) =>
				isAuthenticated || isAuthInProgress ? (
					<Component {...props} />
				) : (
					<Redirect to="/auth" />
				)
			}
		/>
	);
};
